var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25708 12.5482V5.13138C2.25708 4.1017 2.85321 3.85396 3.58095 4.5817L5.58611 6.58686C5.88805 6.8888 6.38353 6.8888 6.67772 6.58686L9.44934 3.80751C9.75127 3.50557 10.2468 3.50557 10.5409 3.80751L13.3203 6.58686C13.6222 6.8888 14.1177 6.8888 14.4119 6.58686L16.4171 4.5817C17.1448 3.85396 17.7409 4.1017 17.7409 5.13138V12.5559C17.7409 14.8785 16.1926 16.4269 13.87 16.4269H6.12805C3.99127 16.4191 2.25708 14.6849 2.25708 12.5482Z",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownPurple);
export default __webpack_public_path__ + "static/media/crown-purple.59a8fb1d55fdc318dadc7b1ab143d609.svg";
export { ForwardRef as ReactComponent };